import { IObjectMap, ITemplateObject } from "admin/appModel/Website";
import { ActivatedRoute, ActivatedRouteSnapshot, Router } from "@angular/router";
import { asEnumerable } from "linq-es2015";
import { NameValueItem } from "admin/appModel/Generic";

export class Utils {
    static GetUrlParam = (window: Window, name: string): string => {
        var url = new URL(window.location.href);

        let value: string = null;

        url.searchParams.forEach((val: string, key: string) => {
            if (key.toLowerCase() != name.toLowerCase()) return;
            value = val;
        });

        return value;
    };

    static Last = (items: string[]): string => {
        return (!items || items.length == 0) ? null : items[items.length - 1];
    };

    static Clone(item: any): any {
        const citem = JSON.parse(JSON.stringify(item));
        return citem;
    }
    static CloneArray(items: any[]): any[] {
        return this.Clone(items);
    }

    static MakeId(length: number): string {
        let result = '';
        const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        const charactersLength = characters.length;
        for (let i = 0; i < length; i++) {
            result += characters.charAt(Math.floor(Math.random() * charactersLength));
        }
        return result;
    }

    static GetObjectParseNameFromFileName(file: string): string {
        const parts = file.split('/');

        const fileNameAndExt = parts.reverse()[0];
        const fileNameAndExtParts = fileNameAndExt.split('.');
        fileNameAndExtParts.pop();

        const fileName = fileNameAndExtParts.join('.');

        const itemParts = asEnumerable(fileName)
            .Reverse()
            .SkipWhile(itm => itm != ')')
            .Skip(1)
            .TakeWhile(itm => itm != '(')
            .Reverse()
            .ToArray();

        const item = itemParts.join('');

        return item;
    }

    static GetObjectParseNameFromFileNameAndExt(file: string): string {
        const fileName = this.GetObjectParseNameFromFileName(file);
        return fileName + ".html";
    }
}

export class RegExpUtils {
    static CheckDomain(domain: string): boolean {
        if (domain.indexOf(" ") >= 0) return false;
        let domainRegEx = new RegExp("^(([a-zA-Z]{1})|([a-zA-Z]{1}[a-zA-Z]{1})|([a-zA-Z]{1}[0-9]{1})|([0-9]{1}[a-zA-Z]{1})|([a-zA-Z0-9][a-zA-Z0-9-_]{1,61}[a-zA-Z0-9]))\.([a-zA-Z]{2,6}|[a-zA-Z0-9-]{2,30}\.[a-zA-Z]{2,3})$");
        return domainRegEx.test(domain);
    }

    static CheckSubdomainName(subdomain: string): boolean {
        if (subdomain.indexOf(" ") >= 0) return false;
        let subdomainRegEx = new RegExp("^([A-Za-z0-9](?:[A-Za-z0-9\-]{0,61}[A-Za-z0-9])?)$");
        return subdomainRegEx.test(subdomain);
    }
}

export class RouterUtils {
    static GetParamByNameFromSnapshotRoot(route: ActivatedRouteSnapshot, name: string): any {
        let r: ActivatedRouteSnapshot = route;

        const findRoute = (): boolean => {
            if (r.paramMap.has(name)) {
                return true;
            }

            if (!r.children || r.children.length == 0) {
                return false;
            }

            for (let cr of r.children) {
                r = cr;
                if (findRoute()) return true;
            }

            return false;
        };

        if (findRoute()) {
            return r.paramMap.get(name);
        }

        return null;
    }
    static GetParamByName(route: ActivatedRoute, name: string): any {
        let r: ActivatedRoute = route;

        const findRoute = (): boolean => {
            if (r.snapshot.paramMap.has(name)) {
                return true;
            }

            if (!r.parent) {
                r = null;
                return false;
            }

            r = r.parent;

            return findRoute();
        };

        if (findRoute()) {
            return r.snapshot.paramMap.get(name);
        }

        return null;
    }
    static HasParamByName(route: ActivatedRoute, name: string): boolean {
        let r: ActivatedRoute = route;

        const findRoute = (): boolean => {
            if (r.snapshot.paramMap.has(name)) {
                return true;
            }

            if (!r.parent) {
                r = null;
                return false;
            }

            r = r.parent;

            return findRoute();
        };

        return findRoute();
    }
    static HasUrlPartPathName(route: ActivatedRoute, name: string): boolean {
        for (let path of route.snapshot.pathFromRoot) {
            const index = path.url.findIndex(itm => itm.path.toLowerCase() == name.toLowerCase());
            if (index >= 0) return true;
        }
        return false;
    }
    static HasAnyUrlPartPathName(route: ActivatedRoute, name: string[]): boolean {
        for (let n of name) {
            if (!this.HasUrlPartPathName(route, n)) continue;
            return true;
        }
        return false;
    }
    static HasUrlPartPathNameFromRouter(router: Router, name: string): boolean {
        const r = router.url.split('/');
        var idx = r.findIndex(itm => itm.toLowerCase() == name.toLowerCase());
        return idx >= 0;
    }
}

declare global {
    interface Array<T> {
        GetObjectMap(name: string): T;
        HasObjectMap(name: string): boolean;
        AddOrUpdateAttribute(name: string, value: string): void;
        /**
         * Is looking for an attribute with same name
         * @param name
         * @param caseSensitive default is false, it ignores case
         */
        HasAttribute(name: string, caseSensitive?: boolean): boolean;
        /**
         * Is looking for an specific attribute
         * @param name
         * @param value
         * @param caseSensitive default is false, it ignores case
         */
        HasAttributeWithValue(name: string, value: string, caseSensitive?: boolean): boolean;
        GetAttributeValue(name: string): string;
        GetAttributeValueAsBoolean(name: string): boolean;
        GetAttributeValueAsNumber(name: string): number;

        distinct(): T[];
        sortObjectByStringProp(propName: string): T[];
        sortObjectByNumberProp(propName: string): T[];
    }
    interface Object {
        GetObjectMapFromPath(...names: string[]): any;
        HasObjectMapFromPath(...names: string[]): boolean;
        HasGlobals(): boolean;
        HasGlobalName(name: string): boolean;
		GetAttributeValue(name: string): string;
    }
}
Object.defineProperty(Array.prototype, 'distinct', {
    value: function<T> (): T[] {
        const objs = this as T[];
        const result = objs.filter((value, index, self) => { return self.indexOf(value) === index; });
        return result;
    },
    writable: true,
    configurable: true
});
Object.defineProperty(Array.prototype, 'sortObjectByStringProp', {
    value: function <T>(propName: string): T[] {
        const objs = this as T[];
        const result = objs.sort((a, b) => {
            const nameA = !a[propName] ? "" : a[propName].toUpperCase();
            const nameB = !b[propName] ? "" : b[propName].toUpperCase();
            if (nameA < nameB) {
                return -1;
            }
            if (nameA > nameB) {
                return 1;
            }
            return 0;
        });
        return result;
    },
    writable: true,
    configurable: true
});
Object.defineProperty(Array.prototype, 'sortObjectByNumberProp', {
    value: function <T>(propName: string): T[] {
        const objs = this as T[];
        const result = objs.sort((a, b) => {
            const nameA = !a[propName] ? 0 : a[propName] as number;
            const nameB = !b[propName] ? 0 : b[propName] as number;
            return nameA - nameB;
        });
        return result;
    },
    writable: true,
    configurable: true
});
Object.defineProperty(Array.prototype, 'GetObjectMap', {
    value: function (name: string): IObjectMap {
        const obj = this as IObjectMap[];
        for (let itm of obj) {
            if (itm.Name == name) return itm;
        }
        return null;
    },
    writable: true,
    configurable: true
});
Object.defineProperty(Array.prototype, 'HasObjectMap', {
    value: function (name: string): boolean {
        const obj = this as IObjectMap[];
        for (let itm of obj) {
            if (itm.Name == name) return true;
        }
        return false;
    },
    writable: true,
    configurable: true
});
Object.defineProperty(Array.prototype, 'AddOrUpdateAttribute', {
    value: function (name: string, value: string): void {
        const obj = this as NameValueItem[];

        if (!obj || obj.length == 0) return null;

        const index = obj.findIndex(itm => itm.Name && itm.Name == name);

        if (index > -1) {
            obj[index].Value = value;
            return;
        }

        const newAttribute = new NameValueItem();
        newAttribute.Name = name;
        newAttribute.Value = value;

        obj.push(newAttribute);
    },
    writable: true,
    configurable: true
});
Object.defineProperty(Array.prototype, 'HasAttribute', {
    value: function (name: string, caseSensitive?: boolean): boolean {
        const obj = this as NameValueItem[];

        if (!obj || obj.length == 0) return null;

        const iscs = caseSensitive == undefined ? false : caseSensitive;

        const index = !iscs ?
            obj.findIndex(itm => itm.Name && itm.Name.toLowerCase() == name.toLowerCase()) :
            obj.findIndex(itm => itm.Name && itm.Name == name);

        return index > -1;
    },
    writable: true,
    configurable: true
});
Object.defineProperty(Array.prototype, 'HasAttributeWithValue', {
    value: function (name: string, value: string, caseSensitive?: boolean): boolean {
        const obj = this as NameValueItem[];

        if (!obj || obj.length == 0) return null;

        const iscs = caseSensitive == undefined ? false : caseSensitive;

        const index = !iscs ?
            obj.findIndex(itm => itm.Name && itm.Name.toLowerCase() == name.toLowerCase() && itm.Value && itm.Value.toLowerCase() == value.toLowerCase()) :
            obj.findIndex(itm => itm.Name && itm.Name == name && itm.Value && itm.Value == value);

        return index > -1;
    },
    writable: true,
    configurable: true
});
Object.defineProperty(Array.prototype, 'GetAttributeValue', {
    value: function (name: string): string {
        const obj = this as NameValueItem[];

        if (!obj || obj.length == 0) return null;

        const index = obj.findIndex(itm => itm.Name && itm.Name.toLowerCase() == name.toLowerCase());
        if (index == -1) return null;

        const attribute = obj[index];

        return attribute.Value;
    },
    writable: true,
    configurable: true
});
Object.defineProperty(Array.prototype, 'GetAttributeValueAsBoolean', {
    value: function (name: string): boolean {
        const obj = this as NameValueItem[];

        if (!obj || obj.length == 0) return null;

        const index = obj.findIndex(itm => itm.Name && itm.Name.toLowerCase() == name.toLowerCase());
        if (index == -1) return null;

        const attribute = obj[index];

        return attribute.Value == "true";
    },
    writable: true,
    configurable: true
});
Object.defineProperty(Array.prototype, 'GetAttributeValueAsNumber', {
    value: function (name: string): number {
        const obj = this as NameValueItem[];

        if (!obj || obj.length == 0) return null;

        const index = obj.findIndex(itm => itm.Name && itm.Name == name);
        if (index == -1) return null;

        const attribute = obj[index];

        const value = Number(attribute.Value);

        if (isNaN(value)) return null;

        return value;
    },
    writable: true,
    configurable: true
});
Object.defineProperty(Object.prototype, 'GetObjectMapFromPath', {
    value: function (...names: string[]): IObjectMap {
        const obj = this as IObjectMap;

        if (!obj.Objects.HasObjectMap(names[0])) return null;
        const itm = obj.Objects.GetObjectMap(names[0]);

        var ncopy = names.slice();
        ncopy.shift();

        if (ncopy.length == 0) return itm;

        return itm.GetObjectMapFromPath(...ncopy);
    },
    writable: true,
    configurable: true
});
Object.defineProperty(Object.prototype, 'HasObjectMapFromPath', {
    value: function (...names: string[]): boolean {
        const obj = this as IObjectMap;

        if (!obj.Objects.HasObjectMap(names[0])) return false;
        const itm = obj.Objects.GetObjectMap(names[0]);

        var ncopy = names.slice();
        ncopy.shift();

        if (ncopy.length == 0) return true;

        return itm.HasObjectMapFromPath(...ncopy);
    },
    writable: true,
    configurable: true
});
Object.defineProperty(Object.prototype, 'HasGlobals', {
    value: function (): boolean {
        const obj = this as IObjectMap;

        if (!obj.ExternalObjects || obj.ExternalObjects.length == 0) return false;
        const globalIndex = obj.ExternalObjects.findIndex(itm => itm.IsGlobal);
        
        return globalIndex >= 0;
    },
    writable: true,
    configurable: true
});
Object.defineProperty(Object.prototype, 'HasGlobalName', {
    value: function (name: string): boolean {
        const obj = this as IObjectMap;

        if (!obj.ExternalObjects || obj.ExternalObjects.length == 0) return false;
        const globalIndex = obj.ExternalObjects.findIndex(itm => itm.IsGlobal && itm.Name.toLowerCase() == name.toLowerCase());

        return globalIndex >= 0;
    },
    writable: true,
    configurable: true
});
Object.defineProperty(Object.prototype, 'GetAttributeValue', {
    value: function (name: string): string {
        const obj = this as ITemplateObject;
        if (!obj.Map || !obj.Attributes || obj.Attributes.length == 0) return "";
        return obj.Attributes.GetAttributeValue(name);
    },
    writable: true,
    configurable: true
});

export class MakePromise<T>
{
    promise: Promise<T>;
    resolve: (value: T) => void;
    reject: (value: any) => void;

    constructor() {
        this.promise = new Promise<T>((resolve: (value: T) => void, reject: (value: any) => void) => {
            this.resolve = resolve;
            this.reject = reject;
        });
    }
}

export class MakePromiseVoid
{
    promise: Promise<void>;
    resolve: () => void;
    reject: (value: any) => void;

    constructor() {
        this.promise = new Promise<void>((resolve: () => void, reject: (value: any) => void) => {
            this.resolve = resolve;
            this.reject = reject;
        });
    }
}

export class ItemCallBuffer<T>
{
    private caller: () => Promise<T>;

    constructor(caller: () => Promise<T>) {
        this.caller = caller;
    }

    private callStore: ((value: T) => void)[] = [];
    private callWait(): Promise<T> {
        return new Promise<T>((resolve: (value: T) => void, reject: (value: any) => void) => {
            this.callStore.push(resolve);
        });
    }

    private callLoading: boolean = false;

    async Call(): Promise<T> {
        if (this.callLoading) {
            return await this.callWait();
        }
        this.callLoading = true;

        const result = await this.caller();

        for (let item of this.callStore) {
            if (!item) continue;
            item(result);
        }

        this.callLoading = false;
        return result;
    }
}

export class ArrayCallBuffer<T>
{
    private caller: () => Promise<T[]>;

    constructor(caller: () => Promise<T[]>) {
        this.caller = caller;
    }

    private callStore: ((value: T[]) => void)[] = [];
    private callWait(): Promise<T[]> {
        return new Promise<T[]>((resolve: (value: T[]) => void, reject: (value: any) => void) => {
            this.callStore.push(resolve);
        });
    }

    private callLoading: boolean = false;

    async Call(): Promise<T[]> {
        if (this.callLoading) {
            return await this.callWait();
        }
        this.callLoading = true;

        const result = await this.caller();

        for (let item of this.callStore) {
            if (!item) continue;
            item(result);
        }

        this.callLoading = false;
        return result;
    }
}